export type StandardLearningMode = "guided" | "conversation";

export function getBaseLanguageCode(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const normalized = value.trim().replace(/_/g, "-").toLowerCase();
  if (!normalized) return null;
  const [base] = normalized.split("-");
  return /^[a-z]{2,8}$/.test(base) ? base : null;
}

export function hasSameBaseLanguage(
  targetLanguageCode: unknown,
  instructionLanguageCode: unknown
): boolean {
  const targetBase = getBaseLanguageCode(targetLanguageCode);
  const instructionBase = getBaseLanguageCode(instructionLanguageCode);
  return Boolean(targetBase && instructionBase && targetBase === instructionBase);
}

export function deriveStandardLearningMode(
  targetLanguageCode: unknown,
  instructionLanguageCode: unknown
): StandardLearningMode {
  return hasSameBaseLanguage(targetLanguageCode, instructionLanguageCode)
    ? "conversation"
    : "guided";
}

export function parseStandardLearningMode(value: unknown): StandardLearningMode | undefined {
  return value === "guided" || value === "conversation" ? value : undefined;
}

export function getGuidedInstructionLanguageCode({
  targetLanguageCode,
  rememberedInstructionLanguageCode,
  fallbackInstructionLanguageCode,
}: {
  targetLanguageCode: string;
  rememberedInstructionLanguageCode?: string | null;
  fallbackInstructionLanguageCode: string;
}): string {
  if (
    rememberedInstructionLanguageCode &&
    !hasSameBaseLanguage(targetLanguageCode, rememberedInstructionLanguageCode)
  ) {
    return rememberedInstructionLanguageCode;
  }

  return fallbackInstructionLanguageCode;
}
